export default __webpack_public_path__ + "static/media/schoolChildren.cc4119d9.png";